import * as React from 'react'
import PropTypes from 'prop-types'
import TextLink from '../TextLink'
import { Title, Paragraph } from '../styles/Text'
import { EpicCoverageWrapper, ThreeBoltsWrapper, Tagline } from './styles'
import ThreeBolts from '../../static/images/threeBolts.svg'
import ThreeBoltsWhite from '../../static/images/threeBoltsWhite.svg'

const EpicCoverage = ({ title, dark }) => (
  <EpicCoverageWrapper>
    <Title center marginBottom="60px">
      {title}
    </Title>
    <ThreeBoltsWrapper>
      <img src={dark ? ThreeBoltsWhite : ThreeBolts} alt="" />
    </ThreeBoltsWrapper>
    <Tagline>
      We’re powered by the expansive Three network, which means fast 4G or 3G
      for 99.5% of the UK population (outdoor).
    </Tagline>
    <Paragraph center>
      <TextLink to="/coverage-checker">Check your coverage</TextLink>
    </Paragraph>
  </EpicCoverageWrapper>
)

EpicCoverage.propTypes = {
  title: PropTypes.string,
  dark: PropTypes.bool,
}

export default EpicCoverage
